<div class="main-card link-item">
  <div class="link-header">
    <h5 class="font-bold font-14">{{ label }}</h5>
    <span class="mode font-12 font-bold">{{ mode }}</span>
  </div>

  <div class="link-text font-14 font-regular">
    {{ link }}
  </div>

  <div class="link-actions">
    <button class="btn btn-copy font-12 font-bold" (click)="copyLink()">نسخ</button>
    <button class="btn btn-open font-12 font-bold" (click)="openLink()">فتح</button>
  </div>
</div>
